import { useTranslation } from 'react-i18next';
import { Button, Chip, Paper, Stack, Typography } from '@mui/material';
import { Menu, MenuStatus } from '../types';

interface PublishingTabProps {
  menu: Menu;
  onPublish?: () => void;
}

const statusColor: Record<MenuStatus, 'success' | 'warning' | 'info' | 'default'> = {
  [MenuStatus.Live]: 'success',
  [MenuStatus.Scheduled]: 'warning',
  [MenuStatus.Draft]: 'info',
  [MenuStatus.Archived]: 'default',
};

const PublishingTab = ({ menu, onPublish }: PublishingTabProps) => {
  const { t } = useTranslation('menus');
  const { publishing } = menu;

  return (
    <Paper variant="outlined"
      sx={{ p: 4 }}>
      <Stack spacing={4}>
        <Stack direction="row"
          alignItems="center"
          spacing={2}>
          <Typography variant="textSM"
            color="text.secondary">{t('publishStatus', 'Publish Status')}</Typography>
          <Chip label={t(`status.${publishing.publishStatus}`, publishing.publishStatus)}
            color={statusColor[publishing.publishStatus]}
            size="small" />
        </Stack>
        {publishing.publishedDate && (
          <Typography variant="textSM">
            {t('publishedDate', 'Published Date')}: {publishing.publishedDate}
          </Typography>
        )}
        <Stack spacing={0.5}>
          <Typography variant="textXS"
            color="text.secondary">{t('channels', 'Channels')}</Typography>
          <Stack direction="row"
            spacing={1}
            flexWrap="wrap">
            {publishing.channels.length === 0
              ? <Typography variant="textSM"
                color="text.secondary">{t('noChannels', 'No channels configured.')}</Typography>
              : publishing.channels.map((channel) => (
                <Chip key={channel}
                  label={channel}
                  size="small" />
              ))}
          </Stack>
        </Stack>
        {onPublish && menu.status !== MenuStatus.Live && (
          <Button onClick={onPublish}
            sx={{ alignSelf: 'flex-start' }}>
            {t('publishNow', 'Publish Now')}
          </Button>
        )}
      </Stack>
    </Paper>
  );
};

export default PublishingTab;
